import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";

interface AddCityActionsProps {
  onDismiss: React.Dispatch<React.SetStateAction<boolean>>;
  isSubmitting?: boolean;
}
export const AddCityActions = ({ onDismiss, isSubmitting }: AddCityActionsProps) => {
  return (
    <DialogFooter className="sm:justify-between py-8">
      <Button variant="secondary" onClick={() => onDismiss(false)} type="button">
        Annuler
      </Button>
      <Button disabled={isSubmitting} type="submit">
        Enregistrer
      </Button>
    </DialogFooter>
  );
};
